import React, { MutableRefObject } from 'react'
import 'focus-visible/dist/focus-visible'
import { FieldInputProps } from 'formik'

import { Fieldset } from '../..'
import useSelectionControlV2 from '../hooks/useSelectionControlV2'

import { Radio } from '.'
import { ISelectionControlOption } from '../form.types'

export interface RadioGroupProps {
  name: string
  legend: string
  options: ISelectionControlOption[]
  onChange?: (selectedOptions: string[] | string) => void
  field?: FieldInputProps<any>
  helpText?: string | JSX.Element
  ErrorMessages?: React.FC<any>
  className?: string
  fieldRef?: MutableRefObject<HTMLInputElement | null>
  value?: string
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  legend,
  options,
  onChange,
  field,
  helpText,
  ErrorMessages,
  className,
  fieldRef,
  value: initialValue,
}: RadioGroupProps) => {
  const { selectOptions, onOptionChange } = useSelectionControlV2(
    options,
    initialValue,
    onChange
  )

  return (
    <Fieldset legend={legend} helpText={helpText} role="radiogroup">
      {ErrorMessages && <ErrorMessages />}
      {selectOptions.map(
        ({
          selected,
          disabled,
          label,
          helpText,
          value,
        }: ISelectionControlOption) => (
          <Radio
            {...field}
            ref={fieldRef}
            id={`${name}-${value}`}
            key={`${name}-${value}`}
            name={name}
            value={value}
            className={className}
            checked={!!selected}
            helpText={helpText}
            onChange={(e) => {
              onOptionChange(e)
              field?.onChange(e)
            }}
            disabled={disabled}
          >
            {label}
          </Radio>
        )
      )}
    </Fieldset>
  )
}

export default RadioGroup
